"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRoles = exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _FiltersMenu = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/FiltersMenu"));

var _CheckboxFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/CheckboxFilterSelector"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getUserRoles = function getUserRoles(roles) {
  return roles.map(function (role) {
    return {
      id: role.id.toString(),
      name: role.label,
      value: role.id.toString()
    };
  });
};

exports.getUserRoles = getUserRoles;

var mainRoles = function mainRoles(roles) {
  return _CheckboxFilterSelector.default.create({
    id: 'mainRoles',
    name: 'Primary Role',
    items: getUserRoles(roles),
    conditions: getCheckboxSelectorConditions()
  });
};

var customRoles = function customRoles(roles) {
  return _CheckboxFilterSelector.default.create({
    id: 'customRoles',
    name: 'Custom role',
    items: getUserRoles(roles),
    conditions: getCheckboxSelectorConditions()
  });
};

var getCheckboxSelectorConditions = function getCheckboxSelectorConditions() {
  return [{
    id: 'selector-in',
    name: 'Is one of',
    value: 'in',
    showItems: true
  }, {
    id: 'selector-not-in',
    name: 'Is not one of',
    value: 'not_in',
    showItems: true
  }];
};

var UserRolesFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UserRolesFilter, _Component);

  var _super = _createSuper(UserRolesFilter);

  function UserRolesFilter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserRolesFilter);
    _this = _super.call(this, props);
    _this.state = {
      selectedRoleType: ''
    };
    _this.onApplyFilters = _this.onApplyFilters.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UserRolesFilter, [{
    key: "onApplyFilters",
    value: function onApplyFilters(filterType, data) {
      var _this$props = this.props,
          filterId = _this$props.filterId,
          onChange = _this$props.onChange;
      onChange(filterId, filterType, data);
      this.setState({
        selectedRoleType: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _selectedItems$mainRo,
          _selectedItems$mainRo2,
          _selectedItems$mainRo3,
          _selectedItems$mainRo4,
          _selectedItems$custom,
          _selectedItems$custom2,
          _selectedItems$custom3,
          _selectedItems$custom4,
          _this2 = this;

      var _this$props2 = this.props,
          customClassName = _this$props2.customClassName,
          title = _this$props2.title,
          isDropdownOpen = _this$props2.isDropdownOpen,
          toggleDropdown = _this$props2.toggleDropdown,
          resetDropdown = _this$props2.resetDropdown,
          userRoles = _this$props2.userRoles,
          selectedItems = _this$props2.selectedItems,
          onClear = _this$props2.onClear,
          onChange = _this$props2.onChange,
          isLoading = _this$props2.isLoading,
          dataElementName = _this$props2.dataElementName,
          dataTrackType = _this$props2.dataTrackType;
      var selectedRoleType = this.state.selectedRoleType;
      var appliedFilters = {
        mainRoles: {
          condition: (_selectedItems$mainRo = (_selectedItems$mainRo2 = selectedItems.mainRoles) === null || _selectedItems$mainRo2 === void 0 ? void 0 : _selectedItems$mainRo2.condition) !== null && _selectedItems$mainRo !== void 0 ? _selectedItems$mainRo : 'in',
          data: (_selectedItems$mainRo3 = (_selectedItems$mainRo4 = selectedItems.mainRoles) === null || _selectedItems$mainRo4 === void 0 ? void 0 : _selectedItems$mainRo4.rolesList.map(function (d) {
            return {
              value: d,
              id: d
            };
          })) !== null && _selectedItems$mainRo3 !== void 0 ? _selectedItems$mainRo3 : [],
          showItems: true
        },
        customRoles: {
          condition: (_selectedItems$custom = (_selectedItems$custom2 = selectedItems.customRoles) === null || _selectedItems$custom2 === void 0 ? void 0 : _selectedItems$custom2.condition) !== null && _selectedItems$custom !== void 0 ? _selectedItems$custom : 'in',
          data: (_selectedItems$custom3 = (_selectedItems$custom4 = selectedItems.customRoles) === null || _selectedItems$custom4 === void 0 ? void 0 : _selectedItems$custom4.rolesList.map(function (d) {
            return {
              value: d,
              id: d
            };
          })) !== null && _selectedItems$custom3 !== void 0 ? _selectedItems$custom3 : [],
          showItems: true
        }
      };
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)("filter-option-".concat(customClassName), 'filter-option')
      }, (0, _preact.h)(_Button.default, {
        disabled: isLoading,
        title: (0, _preact.h)(FilterTitle, {
          title: title,
          onClear: onClear,
          isDropdownOpen: isDropdownOpen,
          selectedItems: selectedItems,
          userRoles: userRoles
        }),
        size: "medium",
        className: (0, _classnames.default)("".concat(customClassName, "-open-button"), 'filter-option-button', {
          'dropdown-open': isDropdownOpen
        }),
        "data-element-name": dataElementName,
        "data-track-type": dataTrackType,
        onClick: function onClick() {
          return toggleDropdown(!isDropdownOpen);
        }
      }), isDropdownOpen && (0, _preact.h)("div", {
        className: "overview__filters-box-container"
      }, (0, _preact.h)("div", {
        className: "overview__filters-box"
      }, (0, _preact.h)(_FiltersMenu.default, {
        areFiltersOpenFromFilterPill: false,
        selectedFilter: selectedRoleType,
        appliedFilters: appliedFilters,
        filters: [mainRoles(userRoles.mainRoles), customRoles(userRoles.customRoles)],
        onFilterClick: function onFilterClick(filterId) {
          _this2.setState({
            selectedRoleType: filterId
          });
        },
        onFilterBack: function onFilterBack() {
          _this2.setState({
            selectedRoleType: ''
          });
        },
        onApplyFilters: this.onApplyFilters,
        onCancelFilters: resetDropdown,
        onLoad: function onLoad() {}
      }))));
    }
  }]);
  return UserRolesFilter;
}(_preact.Component);

var FilterTitle = function FilterTitle(_ref) {
  var title = _ref.title,
      onClear = _ref.onClear,
      selectedItems = _ref.selectedItems,
      isDropdownOpen = _ref.isDropdownOpen;
  var countSeletedCustomRole = selectedItems.customRoles.rolesList.length;
  var countSeletedMainRole = selectedItems.mainRoles.rolesList.length;
  return (0, _preact.h)("div", null, (0, _preact.h)("span", {
    className: (0, _classnames.default)('dropdown-placeholder-text', {
      'filter-dropdown-open': isDropdownOpen
    })
  }, title), countSeletedMainRole === 0 && countSeletedCustomRole === 0 && (0, _preact.h)("span", {
    className: "dropdown-selected-placeholder"
  }, "All"), countSeletedMainRole > 0 && (0, _preact.h)("span", {
    className: "item-summary"
  }, (0, _preact.h)("span", null, "Primary: "), (0, _preact.h)("span", null, selectedItems.mainRoles.condition === 'not_in' ? 'NOT ' : '', countSeletedMainRole, " role", countSeletedMainRole > 1 ? 's' : '')), countSeletedMainRole > 0 && countSeletedCustomRole > 0 && (0, _preact.h)("span", {
    className: (0, _classnames.default)('dropdown-placeholder-text roles-operator', {
      'filter-dropdown-open': isDropdownOpen
    })
  }, "AND"), countSeletedCustomRole > 0 && (0, _preact.h)("span", {
    className: "item-summary"
  }, (0, _preact.h)("span", null, "Custom: "), (0, _preact.h)("span", null, selectedItems.customRoles.condition === 'not_in' ? 'NOT ' : '', countSeletedCustomRole, " role", countSeletedCustomRole > 1 ? 's' : '')), (countSeletedMainRole > 0 || countSeletedCustomRole > 0) && (0, _preact.h)("span", {
    className: "icon-cancel-wrapper",
    onClick: function onClick(e) {
      return onClear(e);
    }
  }, (0, _preact.h)(_assets.default, {
    icon: "cancel",
    customClass: "icon-cancel",
    height: 16,
    width: 16
  }), ' '));
};

var _default = UserRolesFilter;
exports.default = _default;